import React from 'react';
import { Tooltip } from 'antd';
import UserAvatar from '@components/UserAvatar';
import type { AwStateStageMember } from '@components/Modals/ApprovalModal/ApprovalModal/ApprovalModal';
import { EyePrivateIcon, FlagLineIcon } from '@icons';
import './StageMember.less';

type StageMemberProps = {
  member: AwStateStageMember;
  isShowPriorityText?: boolean;
  isOwner: boolean;
};

export default function StageMember({
  member,
  isOwner,
  isShowPriorityText = true
}: StageMemberProps) {
  const isViewOnly =
    !member.canComment &&
    !member.canDownload &&
    !member.canManageAW &&
    !member.canUploadNewVersion &&
    !member.canSubmitDecision;
  const isPriority = member.hasCommentPriority;
  return (
    <div className="stage-member">
      <UserAvatar
        size="large"
        src={member.picture.url}
        userName={(member.name as any) || ''}
        userEmail={member.email || ''}
        isActive
      />
      <div className="stage-member_info">
        <div className="stage-member_head">
          <Tooltip
            title={member.name || member.email}
            placement="bottom"
            overlayClassName="stage-card_tooltip"
          >
            <div className="stage-member_name">
              {member.name || member.email}
            </div>
          </Tooltip>
          {isOwner && <div className="stage-member_label b-owner">Owner</div>}
          {isPriority && (
            <Tooltip
              title={
                <div style={{ textAlign: 'left', fontWeight: 600 }}>
                  This mark indicates the priority of the stage
                  <br />
                  reviewer.
                </div>
              }
              placement="bottom"
              overlayClassName="stage-card_tooltip"
            >
              <div className="stage-member_label b-priority">
                {isShowPriorityText && 'Priority'}
                <FlagLineIcon />
              </div>
            </Tooltip>
          )}
          {isViewOnly && (
            <Tooltip
              title="View-only participant"
              placement="bottom"
              overlayClassName="stage-card_tooltip"
            >
              <EyePrivateIcon className="stage-member_icon-eye" />
            </Tooltip>
          )}
        </div>
        {member.name && (
          <div className="stage-member_email">{member?.email}</div>
        )}
      </div>
    </div>
  );
}
